import { onBeforeUnmount } from 'vue';

export function useAbortableRequest() {
  let controller: AbortController | null = null;

  function getSignal() {
    controller?.abort();
    controller = new AbortController();
    return controller.signal;
  }

  /**
   * Starts a request that the next call replaces: `isStale` turns true once a
   * newer request starts or the component unmounts, so multi-step loads can
   * stop between steps.
   */
  function startRequest() {
    const signal = getSignal();
    return { signal, isStale: () => signal.aborted };
  }

  onBeforeUnmount(() => controller?.abort());

  return { getSignal, startRequest };
}
